/* The Atelier: HelpfulCrowd card ratings (loaded defer from layout/theme.liquid on pages that can show product cards).
   - Card ratings read "4.9 · 50 reviews": HelpfulCrowd writes the count as "(50 reviews)", so each empty card slot is
     watched (childList only) and the brackets are dropped when the app fills it. The dot is CSS (atelier.css).
   - window.atRefreshReviews() re-hydrates [data-hc="product-rating"] slots added after load (search facets, product
     recommendations; called from facets.js and global.js). No-op until HelpfulCrowd has loaded or when no empty slot
     exists. It sets hc_last_processed_time so the app's own observer does not double-fire, and never calls
     hc_fetch_resources(), which re-initialises every widget. It also runs when the theme editor re-renders a section,
     whose new cards arrive with empty slots. */
(function () {
  function tidy(slot) {
    slot.querySelectorAll('.hc-product-rating__review-count').forEach(function (c) {
      if (/[()]/.test(c.textContent)) c.textContent = c.textContent.replace(/[()]/g, '').trim();
    });
    // The app's five SVGs otherwise become five unnamed images. The score names the whole group once.
    slot.querySelectorAll('.hc-product-rating__stars').forEach(function (stars) {
      var score = stars.querySelector('.hc-product-rating__text');
      var value = score && Number(score.textContent.trim());
      if (value > 0 && value <= 5) {
        stars.setAttribute('role', 'img');
        stars.setAttribute('aria-label', 'Rated ' + value + ' out of 5');
      }
      stars.querySelectorAll('svg').forEach(function (star) { star.setAttribute('aria-hidden', 'true'); });
    });
  }
  var mo = new MutationObserver(function (records) {
    records.forEach(function (r) {
      tidy(r.target);
    });
  });
  function watch() {
    document.querySelectorAll('.at-card-rating [data-hc="product-rating"]').forEach(function (slot) {
      if (slot.firstChild) tidy(slot);
      else mo.observe(slot, { childList: true });
    });
  }
  window.atRefreshReviews = function () {
    watch();
    var d = window.hc_last_widget_data;
    if (!d || !d.css || typeof window.hc_process_static_page !== 'function') return;
    if (!document.querySelector('[data-hc="product-rating"]:empty')) return;
    try {
      window.hc_last_processed_time = Date.now();
      window.hc_process_static_page(d.store_id, d.css.theme, 'product_rating');
    } catch (e) {}
  };
  watch();
  document.addEventListener('shopify:section:load', function () {
    window.atRefreshReviews();
  });
})();
